
var Model = require("../types/Model.js");
import Orientation from "react-native-orientation-locker";
var window = require("global");

module.exports = new Model({
	name: "orientationlocker",
	init: init,
	uninit: uninit,
	triggers: triggers,

	lock: lock,
	unlock: unlock,
});

function init() {
	// Say that it hasn't locked yet
	this.push(false);
}

function uninit() {
	// If not locked, don't worry about it
	if (!this.data) return;
	this.unlock();
}

function triggers() {
	return {
		lock: lock,
		unlock: unlock
	};
}

function lock(data) {
	var orientation = data.orientation || "landscape";
	doLock(orientation);
	this.push(orientation);
}

function unlock() {
	doUnlock();
	this.push(false);
}

function doLock(orientation) {
	if(orientation === "portrait")
		Orientation.lockToPortrait();
	else if(orientation === "landscape")
		Orientation.lockToLandscape();

	recheckScreenOrientation();
}

function doUnlock() {
	Orientation.unlockAllOrientations();
}

function recheckScreenOrientation() {
	var cordova = window.cordova;
	if(!cordova) return;
	if(cordova.recheckScreenOrientation){
		cordova.recheckScreenOrientation();
	}
}
